import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from '@mui/material/DialogContent';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import {styled} from "@mui/material/styles";


const StyledTitle = styled(DialogTitle)(({theme, locked}) => ({
    fontSize: 28,
}));

export default function HelpDialog({ open, onClose }) {

    return (
        <Dialog open={open} onClose={onClose} scroll="body">
            <StyledTitle id={'dialog-title'}>
                How to use
            </StyledTitle>
            <DialogContent dividers>
            <Typography variant={'body1'} gutterBottom paragraph>Amoled-ify by Amoled.in is useful convert images/wallpapers that are dark but not pitch black (#000000), On amoled/oled displays there pixels are turned-off.</Typography>
                <Typography variant={'body1'} gutterBottom paragraph>To use, simply choose an image file and it will load the image.</Typography>
                <Typography variant={'body1'} gutterBottom paragraph>After choosing an image, drag the RGB slider to a value greater than 0.  For each pixel, if the R, G, and B
                    values are less than the threshold, it will set that pixel to pure black and the rest of the pixels will be adjusted for a smooth transition from bright part to dark part.</Typography>
                <Typography variant={'body1'}>The image will update in the preview pane once finished, and the stats will change as well.
                    You can save your image by tapping on the image.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

HelpDialog.defaultProps = {
    open: false,
};
